export default {
	AgeFrom: "ageFrom",
	AgeTo: "ageTo",
	MaritalStatus: "maritalStatus",
	Stance: "stance",
};
